<template>
  <div>
    <!-- Sidebar -->
    <div class="sidebar" id="sidebarLeft">
      <div class="sidebar-inner v-slimscroll">
        <div class="sidebar-menu">
          <!-- {{filterRoomAdvance}} -->
          <ul>
            <!-- <li>
              <router-link to="/index">
                <i class="fa fa-arrow-left"></i>
                <span>Back to Home</span>
              </router-link>
            </li>-->
            <li class="menu-title">
              <!-- <a :href="'../../assets/sounds/incoming.mp3'" @click.prevent="playSound()">cek sound</a> -->
              <span>
                <Skeleton v-if="!!loadingStatus" :count="1" :width="'10px'" :height="'10px'" />
                <span v-else>
                  <i
                    title="Online"
                    class="online text-success fa fa-signal"
                    v-if="isOnlineData.status==1"
                  ></i>
                  <i title="Offline" class="text-danger fa fa-signal" v-else></i>
                </span>
                {{agentSession.license_name}}
                <br />
                <small>
                  <i class="la la-user"></i>
                  {{agentSession.first_name}}
                </small>
              </span>
            </li>
            <li>
              <div class="form-group row mb-1">
                <div class="col-lg-11">
                  <div class="input-group" style="margin-left:5px;">
                    <input
                      class="form-control floating"
                      v-model="serverParam.keywords"
                      type="text"
                      @change="filterRoomByKeywords"
                      placeholder="Search..."
                    />
                    <div class="input-group-append">
                      <button
                        type="button"
                        class="btn btn-white dropdown-toggle"
                        data-toggle="dropdown"
                      >
                        <i
                          class="fa fa-check text-success"
                          v-if="filterRoomAdvance.tags_filter==true"
                        ></i>
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <a
                          class="dropdown-item"
                          @click="showFilter"
                          href="#"
                          data-toggle="modal"
                          data-target="#add_filters"
                        >
                          <i class="fa fa-navicon"></i>
                          <i
                            style="font-size:12px;"
                            class="fa fa-check text-success"
                            v-if="filterRoomAdvance.tags_filter==true"
                          ></i>
                          Filters
                        </a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a
                          class="dropdown-item"
                          @click="showBroadcast"
                          href="#"
                          data-toggle="modal"
                          data-target="#add_broadcast"
                        >
                          <i class="fa fa-send-o"></i> Direct Chats
                        </a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a @click="resolveAll" class="dropdown-item" href="javascript:void(0)">
                          <i class="fa fa-check"></i> Resolve All
                        </a>
                        <div role="separator" class="dropdown-divider"></div>
                        <a @click="readAll" class="dropdown-item" href="javascript:void(0)">
                          <i class="fa fa-envelope-open-o"></i> Read All
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </li>
            <li class="menu-title">
              <div class="row">
                <div class="col-sm-12 col-md-12 text-center">
                  <div class="btn-group btn-group-sm">
                    <button
                      @click.prevent="filterRoomByOptions('')"
                      type="button"
                      :class="'btn '+((currentOptionsValue=='')?'btn-primary':'btn-light') "
                    >Chats</button>
                    <button
                      @click.prevent="filterRoomByOptions('unread')"
                      type="button"
                      :class="'btn '+((currentOptionsValue=='unread')?'btn-primary':'btn-light') "
                    >Unread</button>
                    <button
                      @click.prevent="filterRoomByOptions('resolved')"
                      type="button"
                      :class="'btn '+((currentOptionsValue=='resolved')?'btn-primary':'btn-light')   "
                    >Resolved</button>
                  </div>
                </div>
              </div>
            </li>
            <li v-if="initLoading">
              <Skeleton :count="3" />
            </li>
            <li v-if="roomListArr.length<1">
              <div class="text-center text-muted">No Results</div>
            </li>
            <li :ref="'ref-'+rowArr.id" v-for="(rowArr,index) in roomListArr" :key="index">
              <a
                href="javascript:void(0)"
                @click="switchRoom(rowArr.id,rowArr.room_title,rowArr.room_photo,rowArr.provider)"
              >
                <span class="chat-avatar-sm user-img">
                  <img
                    class="rounded-circle"
                    alt
                    src="@/assets/profiles/avatar-02.jpg"
                    v-if="rowArr.room_photo==''"
                  />
                  <img class="rounded-circle" alt v-lazy="rowArr.room_photo" v-else />
                  <span class="status online fa fa-whatsapp text-info"></span>
                </span>
                <span class="chat-user">
                  {{rowArr.room_title}}
                  <br />
                  <small
                    :ref="'ref-unserved-'+rowArr.id"
                    v-show="(rowArr.num_unread>0)"
                    style="color:blue;"
                  >Unserved</small>
                </span>
                <span
                  :ref="'ref-unread-'+rowArr.id"
                  v-show="(rowArr.num_unread>0)"
                  class="badge badge-pill bg-danger"
                >{{rowArr.num_unread}}</span>
                <span
                  v-show="rowArr.is_resolved_id!=''"
                  class="badge badge-pill bg-success"
                >Resolved</span>
              </a>
            </li>
          </ul>
          <infinite-loading-contact
            spinner="spiral"
            :identifier="infiniteId"
            @infinite="getRoomList"
          >
            <div slot="spinner">
              <span v-if="loading">Loading...</span>
            </div>
            <!-- <div slot="no-more">No more messages</div> -->
            <div slot="no-more">
              <span
                v-if="(this.serverParam.totalRecords>0 && this.serverParam.rendered>=this.serverParam.totalRecords)"
              >No more messages</span>
              <span v-if="(this.serverParam.totalRecords==0)">No more messages</span>
              <span
                v-if="(this.serverParam.totalRecords>0 && this.serverParam.rendered==0)"
              >No more messages</span>
            </div>
            <div slot="no-results">
              <span v-if="(this.serverParam.totalRecords==0)">No results message</span>
              <span v-else>No more messages</span>
            </div>
          </infinite-loading-contact>
        </div>
      </div>
    </div>
    <!-- /Sidebar -->
  </div>
</template>
<script>
import { getWhatsappJid } from "@/utils/helper";
import { mapGetters } from "vuex";
import { Skeleton } from "vue-loading-skeleton";
import InfiniteLoading from "vue-infinite-loading";
// import { useSound } from '@vueuse/sound';
// import incomingSound from '@/assets/sounds/incoming.mp3'
// audioFile.play();
export default {
  components: {
    InfiniteLoadingContact: InfiniteLoading,
    Skeleton
  },
  props: {},
  computed: {
    isFilterAdvanceClear() {
      return this.$store.state.omniroom.isFilterAdvanceClear;
    },
    isFilterAdvanceActive() {
      return this.$store.state.omniroom.isFilterAdvanceActive;
    },
    filterRoomAdvance() {
      return this.$store.state.omniroom.filterRoomAdvance;
    },
    ...mapGetters([
      "roomListArr",
      "agentSession",
      "activeRoomId",
      "NEW_NUM_UNREAD_MESSAGE_ROOM_Data"
    ]),
    numUnreadMessage() {
      return this.$store.state.omniroom.numUnreadMessage;
    },
    RefreshRoomData() {
      return this.$store.state.pusher.RefreshRoomData;
    },
    RemoveRoomData() {
      return this.$store.state.pusher.RemoveRoomData;
    },
    currentpage() {
      return this.$route.path;
    }
  },
  data() {
    // const incomingSound = new Audio("@/assets/sounds/incoming.mp3");

    return {
      currentOptionsValue: "",
      currentTitle: "",
      appTitle: process.env.VUE_APP_TITLE,
      incomingSound: process.env.VUE_APP_SOUNDS_INCOMING,
      newData: [],
      infiniteId: +new Date(),
      initLoading: false,
      loading: false,
      activeClass: "active",
      // activeRoomId: ""
      activeId: "",
      loadingStatus: false,
      isOnlineData: {
        message: "",
        status: 0,
        checkIsOnline: null
      },
      serverParam: {
        keywords: "",
        options: "",
        tags_filter: false,
        untag: false,
        tags_id: [],
        page: 0,
        perPage: 30,
        rendered: 0,
        totalRecords: 0
      },
      paramNumUnread: {
        keywords: "",
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      }
    };
    //  isactive : true
  },
  watch: {
    isFilterAdvanceClear: {
      handler: function(val, oldVal) {
        if (val == true) {
          // console.log("advance filter clear enable");
          this.filterRoomByAdvance();
        }
      }
    },
    isFilterAdvanceActive: {
      handler: function(val, oldVal) {
        if (val == true) {
          // console.log("advance filter enable");
          this.filterRoomByAdvance();
        }
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || appTitle;
        this.currentTitle = to.meta.title || appTitle;
      }
    },
    RemoveRoomData: {
      handler: function(val, oldVal) {
        // console.log("RemoveRoomData:oldVal", oldVal);
        // console.log("newVal", val);
        if (val != null) {
          this.RemoveTakenRoomByOtherAgent(val.room_id, val.agent_id);
        }
      },
      deep: true
    },
    RefreshRoomData: {
      handler: function(val, oldVal) {
        // console.log("RefreshRoomData:oldVal", oldVal);
        // console.log("newVal", val);
        // if (oldVal != val && val != null) {
        //   this.getRoomList();
        // }
        if (val == true) {
          // this.playSound();
          this.numUnread();
          this.onlyGetRoomList();
          this.getNewNumUnreadMessageRoom();
          this.$store.dispatch("pusher/UpdateRefreshRoomData", false);
        }
      },
      deep: true
    },
    NEW_NUM_UNREAD_MESSAGE_ROOM_Data: {
      handler: function(val, oldVal) {
        // console.log("NEW_NUM_UNREAD_MESSAGE_ROOM_Data:oldVal", oldVal);
        // console.log("newVal", val);
        // if (oldVal != val && val != null) {
        //   this.getRoomList();
        // }
        this.numUnread();
        this.addNewRoom(val);
      },
      deep: true
    }
  },
  async created() {
    this.initLoading = await true;
    this.numUnread();
    this.changeRoomListArr([]);
    this.getNewNumUnreadMessageRoom();
    var that = this;
    setTimeout(function() {
      console.log("timeout");
      that.RefreshRoom();
    }, 200);

    await this.isOnline(this.agentSession.license_phone_number);
    await this.pollCheckIsOnline();
    this.initLoading = await false;
    this.$root.$on("addDirectChat", async dataArr => {
      this.addNewRoom(dataArr);
      this.switchRoom(
        dataArr.id,
        dataArr.room_title,
        dataArr.room_photo,
        dataArr.provider
      );
      // console.log("addDirectChat:", dataArr);
    });
  },
  beforeDestroy() {
    clearInterval(this.checkIsOnline);
    this.RefreshRoomUnsub();
  },
  methods: {
    showFilter() {
      this.activeId = "";
      this.changeActiveId("");
      var that = this;
      this.$store.dispatch("omniroom/setIsFilterAdvanceActive", false); //diset false dulu
      setTimeout(function() {
        var liContainer = document.getElementById("add_filters");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("omniroom/setIsShowFilter", true);
        }
      }, 1000);
    },
    async readAll() {
      await this.$fire({
        title: "Are you sure you will Read All chats?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store.dispatch("omniroom/readAll").then(response => {
            this.$fire({
              title: "Success",
              text: response.msg,
              type: "warning",
              timer: 3000
            });
          });
        }
      });

      var that = this;
      setTimeout(function() {
        that.filterRoomByOptions(that.currentOptionsValue);
      }, 5000);
    },
    async resolveAll() {
      await this.$fire({
        title: "Are you sure you will Resolve All chats?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store.dispatch("omniroom/resolveAll").then(response => {
            this.$fire({
              title: "Success",
              text: response.msg,
              type: "warning",
              timer: 3000
            });
          });
        }
      });
    },
    playSound() {
      var audio = new Audio(this.incomingSound);
      audio.play();
    },
    showBroadcast() {
      this.activeId = "";
      this.changeActiveId("");
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_broadcast");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("omniroom/setIsShowBroadcast", true);
        }
      }, 1000);
    },
    showDirectChats() {
      this.activeId = "";
      this.changeActiveId("");
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_chat_user");
        var isShowModal = liContainer.classList.contains("show");
        console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("omniroom/setIsShowDirectChats", true);
        }
      }, 1000);
    },
    RemoveTakenRoomByOtherAgent(roomId, currentAgentId) {
      if (
        this.agentSession.id != "" &&
        this.agentSession.id != currentAgentId
      ) {
        if (this.roomListArr != null) {
          var index = this.roomListArr
            .map(x => {
              return x.id;
            })
            .indexOf(roomId);
          if (index >= 0) {
            this.roomListArr.splice(index, 1);
          }
        }
      }
    },
    async RefreshRoomUnsub() {
      this.$store.dispatch("pusher/RefreshRoom_UNSUB", this.agentSession);
    },
    async RefreshRoom() {
      this.$store.dispatch("pusher/RefreshRoom", this.agentSession);
    },
    pollCheckIsOnline() {
      var that = this;
      this.checkIsOnline = setInterval(() => {
        that.isOnline(that.agentSession.license_phone_number);
        // console.log("pollCheckIsOnline", that.agentSession);
      }, 30000); //refresh per 30 detik
    },
    getWhatsappJid(number) {
      return getWhatsappJid(number);
    },
    async isOnline(phone) {
      this.loadingStatus = await true;

      await this.$store
        .dispatch("omniwa/isOnline", phone)
        .then(response => {
          var { data } = response;
          this.isOnlineData = data;
        })
        .catch(error => {});
      this.loadingStatus = await false;
    },
    async addNewRoom(dataArr) {
      if (typeof dataArr.id != "undefined") {
        var roomId = dataArr.id;
        //hapus dulu id yg sama jika ada sebelum menambahkan

        if (this.roomListArr != null) {
          var index = this.roomListArr
            .map(x => {
              return x.id;
            })
            .indexOf(roomId);
          if (index >= 0) {
            this.roomListArr.splice(index, 1);
          }
          await this.roomListArr.unshift(dataArr);
          await this.changeRoomListArr(this.roomListArr);
        } else {
          var newData = await [dataArr];
          await this.changeRoomListArr(newData);
        }

        if (this.activeRoomId != "") {
          var liContainer = document.getElementById("sidebarLeft");
          var lis = liContainer.getElementsByTagName("li");
          for (var i = 0; i < lis.length; i++) {
            liContainer.querySelector(".active")
              ? liContainer.querySelector(".active").classList.remove("active")
              : "";
          }
        }

        this.roomListArr.forEach(async (row, index) => {
          if (this.activeRoomId == row.id) {
            this.$refs["ref-" + row.id][0].classList.add("active");
            // this.switchRoom(row.id, row.room_title, row.room_photo, "whatsapp");
            this.changeActiveId(row.id); //set agar css active room tidak berubah
          }

          if (row.num_unread > 0) {
            await this.$refs["ref-unread-" + roomId][0].classList.remove(
              "hide"
            );
            await this.$refs["ref-unserved-" + roomId][0].classList.remove(
              "hide"
            );
          }

          // await console.log("roomEnd::", this.roomListArr);
        });
      }
    },
    async getNewNumUnreadMessageRoom() {
      this.$store.dispatch(
        "pusher/NEW_NUM_UNREAD_MESSAGE_ROOM",
        this.agentSession
      );
    },
    async changeRoomListArr(data) {
      // console.log("changeHotChatListArr::", data);
      var newArr = this.getUniqueListBy(data, "id");
      // this.$store.dispatch("omniroom/setHotChatListArr", data);
      this.$store.dispatch("omniroom/setRoomListArr", newArr);
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    changeActiveId(roomId) {
      this.$store.dispatch("omniroom/setActiveRoomId", roomId);
    },
    changeActiveProvider(provider) {
      this.$store.dispatch("omniroom/setActiveProvider", provider);
    },
    async switchRoom(roomId, roomTitle, roomPhoto, provider) {
      // if (this.activeRoomId != "" && this.activeRoomId == roomId) {
      //   return;
      // }
      this.loading = await true;

      if (this.activeId != "") {
        console.log("not empty", this.activeId);
        await this.$refs["ref-" + this.activeId][0].classList.remove("active");
      }

      await this.$refs["ref-" + roomId][0].classList.add("active");
      if (typeof this.$refs["ref-unread-" + roomId] != "undefined") {
        this.$refs["ref-unread-" + roomId][0].classList.add("hide");
        this.$refs["ref-unserved-" + roomId][0].classList.add("hide");
      }
      this.activeId = await roomId;
      // await this.changeActiveId(this.activeId);
      await this.changeActiveId(roomId);
      await this.changeActiveProvider(provider);

      // console.log("roomId:", roomId);
      // console.log("activeId:", this.activeId);
      var dataArr = [];
      dataArr = {
        room_id: roomId,
        room_title: roomTitle,
        room_photo: roomPhoto
      };
      await this.$root.$emit("switchRoom", dataArr);
      this.loading = await false;

      var that = this;
      //refresh pesan blm dibaca
      setTimeout(function() {
        that.numUnread();
      }, 200);
    },
    async numUnread() {
      // console.log("this.activeRoomId", this.activeRoomId);
      // console.log("this.serverParam", this.serverParam);
      this.loading = await true;
      await this.$store
        .dispatch("omniroom/numUnread", this.paramNumUnread)
        .then(response => {
          var { totalRecords } = response;
          if (totalRecords > 0) {
            document.title = "(" + totalRecords + ") " + this.currentTitle;
          } else {
            document.title = this.currentTitle;
          }
          // console.log("totalRecordstotalRecords",totalRecords)
        });
      this.loading = await false;
    },
    async onlyGetRoomList() {
      // console.log("onlyGetRoomList", "OK");
      // console.log("this.activeRoomId", this.activeRoomId);
      // console.log("this.serverParam", this.serverParam);
      this.loading = await true;
      await this.$store.dispatch("omniroom/getRoomList", this.serverParam);
      this.loading = await false;
    },
    async filterRoomByAdvance() {
      this.activeId = "";
      this.changeActiveId("");
      this.changeRoomListArr([]);
      //   console.log("groupId", groupId);
      this.serverParam.totalRecords = 0;
      this.serverParam.rendered = 0;
      if (this.filterRoomAdvance.tags_filter == true) {
        this.serverParam.untag = this.filterRoomAdvance.untag;
        this.serverParam.tags_filter = this.filterRoomAdvance.tags_filter;
        let tagsId = "";
        this.serverParam.tags_id = "";
        if (this.filterRoomAdvance.tags_id.length > 0) {
          this.filterRoomAdvance.tags_id.forEach((tagId, idx) => {
            // this.serverParam.tags_id.push(tagId);
            if (idx == 0) {
              this.serverParam.tags_id = tagId;
            } else {
              this.serverParam.tags_id += "," + tagId;
            }
          });
        }
      } else {
        this.serverParam.untag = false;
        this.serverParam.tags_id = "";
        this.serverParam.tags_filter = false;
      }

      this.serverParam.page = 0;
      this.serverParam.perPage = 30;
      this.infiniteId += 1;
    },
    async filterRoomByKeywords() {
      this.activeId = "";
      this.changeActiveId("");
      this.changeRoomListArr([]);
      //   console.log("groupId", groupId);
      this.serverParam.totalRecords = 0;
      this.serverParam.rendered = 0;
      this.serverParam.page = 0;
      this.serverParam.perPage = 30;
      this.infiniteId += 1;
    },
    async filterRoomByOptions(optionsValue) {
      this.activeId = "";
      this.changeActiveId("");
      this.changeRoomListArr([]);
      //   console.log("groupId", groupId);
      this.serverParam.totalRecords = 0;
      this.serverParam.rendered = 0;
      this.serverParam.options = optionsValue;
      this.serverParam.page = 0;
      this.serverParam.perPage = 30;
      this.infiniteId += 1;
      this.currentOptionsValue = optionsValue;
    },
    async getRoomList($state) {
      // console.log("staaatex", $state);

      // console.log("this.activeRoomId", this.activeRoomId);
      this.loading = await true;
      await this.$store
        .dispatch("omniroom/getRoomList", this.serverParam)
        .then(result => {
          const { data } = result;
          this.newData = data;
          if (this.newData.length > 0) {
            this.roomListArr.push(...this.newData);
            this.changeRoomListArr(this.roomListArr);
            this.serverParam.rendered =
              this.serverParam.page + result.recordsFiltered;
            this.serverParam.page += result.recordsFiltered;

            if (typeof result.data != "undefined" && result.data != null) {
              result.data.forEach((row, index) => {
                if (row.id == this.activeRoomId && this.activeRoomId != "") {
                  var dataArr = {
                    room_id: row.id,
                    room_title: row.room_title,
                    room_photo: row.room_photo
                  };
                  // console.log("prov::", row.provider);
                  this.switchRoom(
                    row.id,
                    row.room_title,
                    row.room_photo,
                    row.provider
                  );
                  return;
                }
              });
            }

            if (result.totalRecords > 0) {
              this.serverParam.totalRecords = result.totalRecords;
            }

            this.loadingMessage = false;
            $state.loaded();
          } else {
            this.loading = false;
            $state.completed();
          }
        })
        .catch(error => {
          //   this.loading = false;
          this.loading = false;

          console.log("error", error);
        });
      this.loading = await false;
    }
  }
};
</script>
           <style>
.hide {
  visibility: hidden !important;
}
.sidebar {
  height: 100vh;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.sidebar::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.sidebar::-webkit-scrollbar-thumb {
  /* background: red;  */
  border-radius: 10px;
  /* background: rgb(204, 204, 204); */
  background-color: transparent;
}

/* Handle on hover */
.sidebar::-webkit-scrollbar-thumb:hover {
  /* background: #b30000;  */
  background: rgb(204, 204, 204);
}
.sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}
</style> 


// WEBPACK FOOTER //
// src/views/omni/LeftSidebar.vue